import { isbot } from 'isbot';
import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useReducer,
} from 'react';
import { Trek } from 'utils/analytics';
import { fullUserAgent, isCordova } from 'utils/platform';

import reducer, { initialState } from './reducer';
import actionsFactory from './reducer/actions';

const initialContext = {
  state: initialState,
  actions: actionsFactory(() => {}),
};

const ExperimentsContext = createContext(initialContext);
const useExperimentsContext = () => useContext(ExperimentsContext);

function ExperimentsContextProvider({ children }) {
  const [state, dispatcher] = useReducer(reducer, initialState);

  const actions = useMemo(() => actionsFactory(dispatcher), [dispatcher]);
  const contextValue = { state, actions };

  useEffect(() => {
    if (isCordova()) {
      return;
    }
    if (isbot(fullUserAgent())) {
      return;
    }
    actions.assignExperimentVariantFromUrl('landingPageTest');
  }, [actions]);

  return (
    <ExperimentsContext.Provider value={contextValue}>
      <Trek context={{ experiments: contextValue.state.experiments }}>
        {children}
      </Trek>
    </ExperimentsContext.Provider>
  );
}

export { useExperimentsContext, ExperimentsContextProvider };
